import React from 'react'
import { ICellRendererParams } from '@ag-grid-community/core'
import { relativeTimeString } from 'enrollment-platform/utils/relative-time-string'
import { Typography } from 'antd'
import { GeneratedFilesCellRenderer } from '../pages/Census/components/GeneratedFilesCellRenderer'
import HrisReportCellRenderer from '../pages/Census/components/HrisReportCellRenderer'
import ZendeskCellRenderer from '../pages/Census/components/ZendeskCellRenderer'
import { HrisCensusReportUploadDto } from '../api/dto/hris-census-report-upload.dto'

const { Text } = Typography

const submittedColumn = {
  headerName: 'Submitted',
  field: 'rowLatestUpdatedAt',
  flex: 1,
  cellRenderer: (params: { value: string }) => (
    <Text className="textSm">{relativeTimeString(params.value)}</Text>
  ),
}

export const getCensusFilesColDefs = ({
  clientNameLookup,
  hasSubmittedColumn = false,
  refreshGrid,
}: {
  clientNameLookup: any
  hasSubmittedColumn: boolean
  refreshGrid: () => void
}) => {
  const colDefs = [
    {
      headerName: 'Uploaded',
      field: 'uploadDatetime',
      flex: 1,
      cellRenderer: (params: { value: string }) => (
        <Text className="textSm">{relativeTimeString(params.value, 1)}</Text>
      ),
    },
    {
      headerName: 'Customer',
      field: 'clientPublicKey',
      sortable: false,
      flex: 1,
      cellRenderer: (params: { value: string | number }) => (
        <Text className="textEmphasis">
          {clientNameLookup[params.value] ?? 'loading...'}
        </Text>
      ),
    },
    {
      headerName: 'HRIS Report',
      field: 'fileName',
      flex: 2,
      sortable: false,
      cellRenderer: (
        params: React.JSX.IntrinsicAttributes &
          ICellRendererParams<HrisCensusReportUploadDto>
      ) => <HrisReportCellRenderer {...params} />,
    },
    {
      headerName: 'Census Files',
      field: 'generatedFiles',
      flex: 3,
      cellRenderer: (
        params: React.JSX.IntrinsicAttributes &
          ICellRendererParams<HrisCensusReportUploadDto> & {
            onSubmit?: (() => void) | undefined
          }
      ) => <GeneratedFilesCellRenderer {...params} onSubmit={refreshGrid} />,
      sortable: false,
      autoHeight: true,
    },
    {
      headerName: 'Zendesk',
      field: 'zendeskTicketId',
      cellRenderer: (params: { data: never }) => (
        <ZendeskCellRenderer data={params.data} onSendComplete={refreshGrid} />
      ),
      suppressHeaderMenuButton: true,
      sortable: false,
      filter: false,
      width: 120,
    },
  ]

  if (hasSubmittedColumn) {
    colDefs.splice(1, 0, submittedColumn)
  }

  return colDefs
}
